import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./../home/home.css";
import { Link } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import InteraktScript from "../../common/InteraktScript";

function Doctorprofile() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [userid, setUserid] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const userIdValue = localStorage.getItem("userId");
    setUserid(userIdValue);
  }, [userid]);

  const doctors = [
    {
      id: 1,
      name: "Dr. Aaradhya Sharma",
      specialization: "Gynaecologist & Your Pregnancy Friend",
      degrees: "MBBS, DGO, MD (Obs & Gyn)",
      Experience: "11 Years of Experience",
      drtext: "My goal is to make you feel so safe and heard, you forget you're talking to a doctor.",
      image: "/Doctorprofile.png",
      link: "/Dr-Aaradhya-Sharma",
    },
    {
      id: 2,
      name: "Dr. Vikram Singh",
      specialization: "Gynaecologist & Your Expert Confidante",
      degrees: "MBBS, DGO (Obs & Gyn)",
      Experience: "16 Years of Experience",
      drtext:"My mission is to replace the fear of the unknown with the confidence that comes from understanding your journey.",
      image: "/Doctorprofile.png",
      link: "/Dr-Vikram-Singh",
    },
    {
      id: 3,
      name: "Dr. Chayya Palan​",
      specialization: "Emotional Health Expert & Partner in Mind-Body Wellness​",
      degrees: "MSc (Clinical Psychology), Advance Diploma in Counselling Psychology",
      Experience: "11 Years of Experience",
      drtext: "A healthy baby begins with a happy, peaceful mother. We're here to care for both of you.",
      image: "/Doctorprofile.png",
      link: "/Dr-Chayya-Palan",
    },
    {
      id: 4,
      name: "Dr. Anuradha Tikhe​",
      specialization: "Dietitian, Your Steady Hand & Reassuring Voice​",
      degrees: "BHMS, MPH (Mumbai), Certified Pregnancy Nutritionist",
      Experience: "16+ Years of Experience",
      drtext: "In all my years of practice, one thing is constant: the need for a calm, experienced hand to hold",
      image: "/Doctorprofile.png",
      link: "/Dr-Anuradha-Tikhe-Dietitian",
    },
        {
      id: 5,
      name: "Dr. Deepak Bhuktar​",
      specialization: "Physician & Your Health Cheerleader​",
      degrees: "MBBS, MD (Internal Medicine)",
      Experience: "15 Years of Experience",
      drtext: "Pregnancy is a celebration of what your body can do! My goal is to make it a joyful and empowering experience.",
      image: "/Doctorprofile.png",
      link: "/Dr-Deepak-Bhuktar",
    },
        {
      id: 6,
      name: "Dr. Gayatri Navale​",
      specialization: "Gynaecologist & Your Safe Space​",
      degrees: "MBBS, DGO, MD (Obs & Gyn)",
      Experience: "13 Years of Experience",
      drtext: "There is no such thing as a 'silly question' or a 'small fear.' Here, everything you feel is valid and important",
      image: "/Doctorprofile.png",
      link: "/Dr-Gayatri-Navale​",
    },
        {
      id: 7,
      name: "Dr. Nisha Kapoor​",
      specialization: "Senior Gynaecologist & Myprega Mentor​",
      degrees: "MBBS, DGO, MD (Obs & Gyn)",
      Experience: "30 Years of Experience",
      drtext: "We are here to transform maternal care from a clinical transaction into a supportive, human relationship",
      image: "/Doctorprofile.png",
      link: "/Dr-Nisha-Kapoor​",
    },
        {
      id: 8,
      name: "Dr. Anuradha Tikhe​",
      specialization: "Mind-Body Guide & Prenatal Yoga Expert​",
      degrees: "BHMS, MPH (Mumbai), Certificate Of Prenatal & Postnatal Yoga",
      Experience: "16+ Years of Experience",
      drtext: "We don't just prepare your body for birth; we train your mind for the beautiful journey of motherhood",
      image: "/Doctorprofile.png",
      link: "/Dr-Anuradha-Tikhe-Yoga",
    },
        {
      id: 9,
      name: "Dr. Anand Narnaware​",
      specialization: "Paediatrician & Your Baby's First Friend​",
      degrees: "MBBS, DNB - Paediatrics, DCH",
      Experience: "17 Years of Experience",
      drtext: "My role begins before your baby arrives, giving you the confidence to welcome your newborn into a healthy, happy home",
      image: "/Doctorprofile.png",
      link: "/Dr-Anand-Narnaware",
    },
        {
      id: 10,
      name: "Crystal Clear Imaging (IIMS Hospital)",
      specialization: "Radiologist & Your Window to the Womb​",
      degrees: "MBBS, MD (Radiodiagnosis), Fellowship in Foetal Medicine",
      Experience: "18 Years of Experience​",
      drtext: "Through my lens, you get the first glimpse of your baby. I ensure every image is a story of health and reassurance",
      image: "/Doctorprofile.png",
      link: "/Crystal-Clear-Imaging-Content",
    },

  ];

  const benefits = [
    {
      icon: "/DoctorprofileIcon1.png",
      title: "Handpicked Human Expertise",
      description:
        'Our journey begins by finding not just the most qualified gynaecologists, but the most compassionate ones. We search for doctors who see pregnancy not as a medical condition, but as a profound human experience. Every doctor is personally interviewed to understand their core philosophy, their communication style, and their capacity for empathy. We ask them about the books they read, their view on a mother\'s intuition, analyse their thought process, and how they build trust. Only those who align with our "care-like-a-mother" philosophy are invited to join.',
    },
    {
      icon: "/DoctorprofileIcon2.png",
      title: "The Myprega Empowerment Training",
      description:
        'This is our promise. Once a doctor joins our family, they undergo rigorous Myprega-exclusive training. This isn\'t about medicine—they are already experts in that. This is about mastering the art of connection. Our Standard Operating Procedures (SOPs) are built around empathy, active listening, taking care of your’s like mother, and empowering you with knowledge. We train them to be your friend first, to answer the "silly" questions with patience, to celebrate your joys, and to calm your fears with genuine warmth. You will not find this level of emotional and communication training in any hospital across India.',
    },
    {
      icon: "/DoctorprofileIcon3.png",
      title: "Empowered by Technology, Driven by Heart",
      description:
        "We then empower these incredible doctors with our technology. Our platform handles the logistics, reminders, reports, and data, freeing your doctor to do what they do best: focus completely on you. This framework ensures you get the best of both worlds—the structured, reliable support of Myprega and the personalized, human touch of a doctor who knows you and your story",
    },
  ];

  const filteredDoctors = doctors.filter((doctor) => {
    const searchableText = [
      doctor.name,
      doctor.specialization,
      doctor.degrees,
      doctor.Experience,
      doctor.drtext,
    ]
      .join(" ")
      .toLowerCase();

    return searchableText.includes(searchTerm.trim().toLowerCase());
  });


  return (
    <div className="new-home">
      <Header userid={userid} />

      <main className="doctor-profile-page">
        {/* <section className="doctor-profile-hero">
          <div className="doctor-profile-shell">
            <div className="doctor-profile-hero-grid">
              <div>
                <h1 className="doctor-profile-title">
                More Than a Doctor. Your Partner in Pregnancy.
                </h1>
                <p className="doctor-profile-subtitle">
                 At Myprega, we believe the best care comes from a deep, human connection.
                 We don't just find great doctors; we find incredible people, and empower them to be your
                 personal guide, friend, and confidante on this beautiful journey.
                </p>
              </div>
              <div className="doctor-profile-hero-media">
                <img src="/Doctorprofile.png" alt="Myprega doctor" />
              </div>
            </div>
          </div>
        </section>

        <section className="doctor-profile-difference">
          <div className="doctor-profile-shell">
            <div className="doctor-profile-section-heading">
              <h2>Why a Myprega Doctor is Different</h2>
              <p>
                 You deserve more than just a medical professional. You deserve a partner who listens,
                 an expert who empathizes, and a guide who cares for you like your mother. That's why
                 our selection and training process is unlike any other in India. We don't just look for
                 qualifications; we look for character.
              </p>
            </div>

            <div className="doctor-benefits-grid">
              {benefits.map((benefit) => (
                <article className="doctor-benefit-card" key={benefit.title}>
                  <div className="benefit-icon green">
                    <img src={benefit.icon} alt="" className="icon" />
                  </div>
                  <h3>{benefit.title}</h3>
                  <p>{benefit.description}</p>
                </article>
              ))}
            </div>
            <p className="doctor-profile-note">We handpicked, vet, and train the best medical experts for
                 and then we empower them with our tech. We don't hide our doctors behind our brand. We
                ate them, so they can elevate your care</p>
          </div>
        </section> */}

        <section className="doctor-directory-header-section">
          <div className="doctor-profile-shell">
            <div className="doctor-directory-bar">
              <div>
                <h2>Meet Your Pregnancy Friends & Guides</h2>
                {/* <p>
                     Below are the incredible individuals who form the heart of Myprega. They are
                     doctors, yes, but they are firstly kind human beings, also mentors, listeners, and passionate
                     advocates for your well-being. Get to know the person who will be walking alongside you. We
                     firmly believe the philosophy that “The good physician treats the disease; the great physician
                     treats the patient.”
                </p> */}
              </div>
              <label className="doctor-search-field" aria-label="Search doctors">
                <FaSearch aria-hidden="true" />
                <input
                  type="search"
                  value={searchTerm}
                  onChange={(event) => setSearchTerm(event.target.value)}
                  placeholder="Search doctors, specialisms..."
                />
              </label>
            </div>
          </div>
        </section>

        <section className="doctor-profile-listing">
          <div className="doctor-profile-shell">
            <div className="doctor-directory-grid">
              {filteredDoctors.map((doctor) => (
                <div className="doctor-directory-item" key={doctor.id}>
                  <div className="doctor-stamp-card doctor-profile-card">
                    <div className="stamp-img-wrapper">
                      <img src={doctor.image} alt={doctor.name} />
                    </div>
                    <div className="doctor-info mt-3">
                      <h4 className="doc-name">{doctor.name}</h4>
                      <p className="doc-specialty">{doctor.specialization}</p>
                      <p className="doc-degree">{doctor.degrees}</p>
                      <p className="doc-experience">{doctor.Experience}</p>
                      <p className="doc-quote-label">I became a pregnancy crafter..</p>
                      <p className="doc-quote">"{doctor.drtext}"</p>
                    </div>
                    <Link
                      to={
                        doctor.link ||
                        `/doctor/${doctor.name.toLowerCase().replace(/\s+/g, "-")}`
                      }
                      className="doctor-profile-card-link"
                    >
                      View Profile
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
      <InteraktScript />
    </div>
  );
}

export default Doctorprofile;
